import React from "react";
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import config from '../config';
import LoginPage from "../pages/LoginPage";
import RegisterPage from "../pages/RegisterPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import UpdatePasswordPage from "../pages/UpdatePasswordPage";

export function UnAuthenticatedRoutes({setUser}) {
  return (
    <Router>
      <Switch>
        <Route exact path="/login">
          <LoginPage onLogin={setUser} />
        </Route>
        {!config.HIDE_REGISTER_PAGE && (
          <Route exact path="/register">
            <RegisterPage onRegister={setUser} />
          </Route>
        )}
        <Route exact path="/forgot">
          <ForgotPasswordPage />
        </Route>
        <Route exact path="/update-password">
          <UpdatePasswordPage />
        </Route>
        <Redirect to="/login" />
      </Switch>
    </Router>
  );
}
